<div class="userManagementContainer">
    <div class="d-flex">
        <div class="scrollableContaier">
            <div class="navbar userContainer">
                <div class="row rowClass" *ngIf="!showInput">
                    <div class="selectClass">
                        <select class="form-select form-select-sm user-sort-select" (change)="sortUserName()"
                            [(ngModel)]="selectedSortOption">
                            <option *ngFor="let result of sortedBy">{{result}}</option>
                            <!-- <option value="name">Sort by Name</option> -->
                        </select>
                    </div>
                    <div class="iconClass">
                        <i class="fa-solid fa-magnifying-glass umIcon" (click)="showSearchField()" tooltip="Search"
                            [options]="myOptions2"></i>
                        <i class="fa-solid fa-circle-plus umIcon" routerLink="newUser" routerLinkActive="active"
                            (click)="getUserList2(userIndex,'new')" tooltip="Add User" [options]="myOptions2"></i>
                    </div>

                </div>
                <div *ngIf="showInput" class="searchInputDiv">
                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                    <input type="search" [(ngModel)]="searchText" class="form-control searchUser"
                        placeholder="search ...">
                    <i class="fa-solid fa-xmark exitIconUser" (click)="showSearchField()" tooltip="Close"
                        [options]="myOptions2"></i>
                </div>
                <div class="userActiveClass">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <a *ngFor="let user of getUserList | search: searchText; index as i" class="userDetail nav-link"
                        [ngClass]="{'active':getUserObject?.sno === user?.sno}" (click)="getUserList2(user?.sno,'user')"
                        routerLink="{{user?.sno}}" routerLinkActive="active">
                        <div class="d-flex">
                            <p>{{user.name}}</p>
                        </div>
                        <div class="d-flex">
                            <span class="days">{{user.created_date | date:'short'}}</span>
                            <a *ngIf="user.active === 'Y'">
                                <i class="fa fa-stop fa-stop1" aria-hidden="true" tooltip="User Status is Active"
                                    [options]="myOptions"></i>
                            </a>
                            <a *ngIf="user.active === 'N'">
                                <i class="fa fa-stop fa-stop2" aria-hidden="true" tooltip="User Status is Deactive"
                                    [options]="myOptions"></i>
                            </a>

                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="secondPart animateH5">
            <app-user-details [userDetailInput]="getUserObject" [getRole]="showSelectParent"
                *ngIf="checkComp === 'user'" [spinnerReceive]="spinnerSent" [closePwdForm]="getValue"
                (deleteUserEmit)="receiveDeleteUserEmit($event)">
            </app-user-details>
           
          <app-new-user (newUserEmit)="receiveNewUserEmit($event)" (addNewUser)="receiveNewUserData($event)"
                *ngIf="checkComp === 'new'"></app-new-user>
        </div>
    </div>
</div>